'use client';

import { CurriculumsFilterContent } from './filter/curriculums-filter-content';

export const CurriculumsFilterLeft = () => {
  return (
    <div className="flex flex-col gap-6 rounded-lg bg-[#F3F3F3] p-6">
      <CurriculumsFilterContent />
    </div>
  );
};
